import React, { useEffect, useState } from "react";
import {
	Autocomplete,
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	IconButton,
	InputLabel,
	TextField,
	Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AlertMsg from "../component/AlertMsg";
import { LoadingButton } from "@mui/lab";
import Axios from "axios";
import constants from "../Constants";
import { useSelector } from "react-redux";

function AddAndEditClass({ modalOpen, setModalOpen, fetchClassList }) {
	const advisors = useSelector(state => state.advisors);
	const [msg, setMsg] = useState(null);
	const [loading, setLoading] = useState(false);
	const [classData, setClassData] = useState({
		name: null,
		advisorId: null,
		description: null,
		room: null,
	});

	const handleInputChange = e => {
		const { name, value } = e.target;
		setClassData(prev => ({
			...prev,
			[name]: value,
		}));
	};

	const addOrEditClassApi = async () => {
		try {
			setLoading(true);
			setMsg(null);
			const method = modalOpen.type === "add" ? "post" : "put";
			const url =
				constants.baseUrl +
				"/class" +
				(method === "put" ? `/${modalOpen.data?.classId}` : "");

			const response = await Axios({
				method,
				url,
				data: { class: classData },
				headers: {
					authorization: "Bearer " + localStorage.getItem("schoolToken"),
				},
			});
			if (response.data.status === 201 || response.data.status === 202) {
				setMsg({
					type: true,
					header: "تلاش موفق",
					message: response.data.result.message,
				});
				fetchClassList();
				setTimeout(() => {
					setModalOpen({ open: false, type: modalOpen.type });
				}, 1000);
			} else {
				setMsg({
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setMsg({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		modalOpen.type === "edit" &&
			setClassData({
				name: modalOpen?.data?.className || null,
				advisorId: modalOpen?.data?.advisorId || null,
				description: modalOpen?.data?.classDescription || null,
				room: null,
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalOpen]);

	return (
		<Dialog open={modalOpen.open} fullWidth maxWidth="xs">
			<Box
				px={2}
				pt={1}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"space-between"}>
				<Typography fontSize={16} fontWeight={700}>
					{modalOpen.type === "add" ? "افزودن کلاس" : "ویرایش کلاس"}
				</Typography>
				<IconButton
					onClick={() => {
						setModalOpen({ open: false, type: modalOpen.type });
					}}>
					<CloseIcon />
				</IconButton>
			</Box>
			<DialogContent>
				{msg ? (
					msg.type ? (
						<AlertMsg message={msg} type={"success"} />
					) : (
						<AlertMsg message={msg} type={"error"} />
					)
				) : null}

				<InputLabel sx={{ mt: 1 }}>نام کلاس</InputLabel>
				<TextField
					name="name"
					value={classData.name || ""}
					onChange={handleInputChange}
					variant="outlined"
					size="small"
					sx={{ mb: 2 }}
					fullWidth
				/>

				<InputLabel>انتخاب مشاور</InputLabel>
				<Autocomplete
					autoHighlight
					options={advisors}
					getOptionLabel={option => option.firstName + " " + option.lastName || ""}
					value={
						advisors.find(advisor => advisor.id === classData.advisorId) || null
					}
					onChange={(e, value) => {
						setClassData(prev => ({
							...prev,
							advisorId: value ? value.id : null,
						}));
					}}
					renderInput={params => (
						<TextField
							{...params}
							variant="outlined"
							fullWidth
							size="small"
							sx={{ mb: 2 }}
						/>
					)}
					noOptionsText="مشاوری یافت نشد"
				/>

				<InputLabel>توضیحات</InputLabel>
				<TextField
					name="description"
					value={classData.description || ""}
					onChange={handleInputChange}
					variant="outlined"
					size="small"
					sx={{ mb: 2 }}
					fullWidth
					multiline
					rows={4}
				/>
			</DialogContent>

			<DialogActions>
				<LoadingButton
					variant="contained"
					color="secondary"
					onClick={addOrEditClassApi}
					sx={{ fontSize: "16px", color: "white", my: 1 }}
					loading={loading}>
					{modalOpen.type === "add" ? "ایجاد" : "ویرایش"}
				</LoadingButton>
				<Button
					variant="contained"
					sx={{ fontSize: "16px", mr: 2, my: 1 }}
					onClick={() => {
						setModalOpen({ open: false, type: modalOpen.type });
						setMsg(null);
					}}>
					انصراف
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default AddAndEditClass;
